// This component is used for yesbank and indusind cards faqs

import { Col, Row, Collapse, Icon, Card, Breadcrumb } from 'antd';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { constants } from '../../devUtils';
import { StyledIndusindFaq } from '../IndusindZingerCardsFaqs/StyledIndusindFaqs';
import { Container } from '../../components';
import { FaQsPropTypes } from '../FundTransfer/FundTransferDatahandler';

const { Panel } = Collapse;

class FaQs extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      Faq: {
        faq = [],
      } = {},
      name = '',
    } = this.props;

    const halfLength = Math.ceil((faq && faq.length) / 2) || 0;

    const leftFaqs = faq && faq.slice(0, halfLength);
    const rightFaqs = faq && faq.slice(halfLength);
    const customExpandIcon = (panelProps) => {
      const { isActive } = panelProps;
      return isActive ? <Icon type="up" /> : <Icon type="down" />;
    };

    const renderAnswers = (answers) => answers.map((answerObj) => (
      <p >
        {answerObj.prefix} {answerObj.answer}
      </p>
    ));

    const LeftWearableFaq = () => (
      <Collapse
        accordion
        expandIconPosition="right"
        expandIcon={customExpandIcon}
        className="wearable-faq-collapse"
      >
        {leftFaqs && leftFaqs.length > 0 && leftFaqs.map((item, index) => {
          const { question, answers = [] } = item || {};
          if (!question || !answers) {
            return null;
          }
          return (
            <Panel
              isActive
              header={question}
              key={index.toString()}
            >
              {renderAnswers(answers)}
            </Panel>
          );
        })}
      </Collapse>
    );

    const RightWearableFaq = () => (
      <Collapse
        accordion
        expandIconPosition="right"
        expandIcon={customExpandIcon}
        className="wearable-faq-collapse"
      >
        {rightFaqs && rightFaqs.length > 0 && rightFaqs.map((item, index) => {
          const { question, answers = [] } = item || {};
          if (!question || !answers) {
            return null;
          }
          return (
            <Panel
              isActive
              header={question}
              key={index.toString()}
            >
              {renderAnswers(answers)}
            </Panel>
          );
        })}
      </Collapse>
    );

    return (
      <StyledIndusindFaq>
        <Container>
          <h2 className="padding-t-2 nomargin-bottom">Manage Zaggle Cards</h2>
          <Breadcrumb separator="<" className="wearable-breadcrumb">
            <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
            <Breadcrumb.Item>{name}</Breadcrumb.Item>
          </Breadcrumb>
          <Card className="rounded wearables-faq">
            <h2 className="margin-b-2">{name}</h2>
            <Row type="flex" justify="start" align="top" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                {LeftWearableFaq()}
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                {RightWearableFaq()}
              </Col>
            </Row>
            {faq.length === 0 && <p>No frequently asked questions found.</p>}
          </Card>
        </Container>
      </StyledIndusindFaq>
    );
  }
}

FaQs.propTypes = FaQsPropTypes;

export { FaQs };



// WEBPACK FOOTER //
// client/containers/NetworkCards/FaQs.js